<template>
  <div class="a-vg-c--body">
    <div class="left-tickets">
      <vdog-active-ticket
          v-for="(ticket, index) in tickets" :key="index"
          :class="inputClass(selected, ticket.Status)"
          :ticket="ticket"
          :currency="currency"
          :isHistory="true"
          @onSelect="openTicket(ticket)"/>
    </div>
    <div class="right-tickets expanded" v-if="currentTicket != null" style="overflow-y: auto;">
      <vdog-active-ticket
        :class="inputClass(selected, currentTicket.Status)"
        :ticket="currentTicket"
        :isHistory="true"
        :currency="currency" />
    </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import VDogHelper from '@/mixins/VDogHelper'
import VDogActiveTicket from '@/components/grayhound/ticket/VDogActiveTicket.vue'

export default {
  components: {
    'vdog-active-ticket': VDogActiveTicket
  },
  data () {
    return {
      currentTicket: null
    }
  },
  mixins: [NumberFormat, VDogHelper],
  props: {
    selected: String,
    tickets: {
      type: Array,
      default: function () {
        return []
      }
    },
    currency: {
      type: String,
      required: true
    },
    currentRound: {
      type: Number,
      required: true
    }
  },
  watch: {
    tickets: function (val, old) {
      this.currentTicket = null
    }
  },
  methods: {
    openTicket (ticket) {
      this.currentTicket = ticket
    }
  }
}
</script>
